<div class="bad-url">
    <div layout="row" flex layout-align="center center">
        <div layout="column" layout-align="center">
          <h1 class="eca-skip-link-focus-target" tabindex="-1"> Page Not Found </h1>
            <p class="large">Sorry, the page you're looking for doesn't exist.</p>
            <p><a href="javascript:history.back()">Back to previous page</a></p>
        </div>
    </div>
  </div>
